import { useEffect } from "react";
import PropTypes from "prop-types";
import NavLogs from "app/pages/Listing/NavLogs/NavLogs";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { fetchNavLogs } from "app/pages/Listing/NavLogs/navLogActionCreators";
import { NAVLOGS_SHOW_SLIDES_NUMBER } from "app/constants";
import { sendTagOnNavlogSeenProducts } from "app/utils/analytics";
import { shouldFetchNavlogs } from "app/pages/Listing/NavLogs/navLogsSelector";

const NavLogsContainer = props => {
	const { resolution, fetchNavLogs, shouldFetchNavlogs, authToken } = props;

	useEffect(() => {
		if (authToken && shouldFetchNavlogs) {
			fetchNavLogs({ authToken }).then(res => {
				const navlogs = res.data;
				if (navlogs && navlogs.length > 0) {
					sendTagOnNavlogSeenProducts(
						navlogs.slice(0, NAVLOGS_SHOW_SLIDES_NUMBER[resolution]).map(product => ({
							...product,
							lastSeenProductType: product.quotationURL ? "quote" : "product",
						}))
					);
				}
			});
		}
	}, [authToken, shouldFetchNavlogs, resolution]);

	return <NavLogs {...props} />;
};

NavLogsContainer.propTypes = {
	fetchNavLogs: PropTypes.func,
	resolution: PropTypes.string,
	shouldFetchNavlogs: PropTypes.bool,
	authToken: PropTypes.string,
};

const mapStateToProps = state => {
	return {
		navLogs: state.navLogs,
		resolution: state.resolution,
		authToken: state.auth.token,
		shouldFetchNavlogs: shouldFetchNavlogs(state),
	};
};

const mapDispatchToProps = dispatch => {
	return bindActionCreators({ fetchNavLogs }, dispatch);
};

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(NavLogsContainer);
